import React from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

const pxToMm = (px) => {
  return Math.floor(px/document.getElementById('myMm').offsetHeight);
};

const mmToPx = (mm) => {
  return document.getElementById('myMm').offsetHeight*mm;
};

const range = (start, end) => {
    return Array(end-start).join(0).split(0).map(function(val, id) {return id+start});
};

const PrintButton = ({id, label}) => (
  <button
    className="btn btn-success boxshadowLight d-none d-lg-inline-block"
    onClick={() => {
      const input = document.getElementById(id);

      html2canvas(input)
        .then((canvas) => {
          const pdf = new jsPDF({
            orientation: 'landscape',
            format: 'letter'
          });

          pdf.addImage(canvas, 0, 0);
          pdf.save(`${id}.pdf`);
        });
    }}
  >Download</button>
);

export default PrintButton;
